import React, { Component } from "react";
import ArticleComments from "./ArticleComments"


class GrimmInterview extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }
    var questionStyle ={
      fontSize:16,
      fontWeight:600
    }

    var answerStyle = {
      fontSize:16
    }

    var interviewerNoteStyle = {
      fontSize: 13,
      fontStyle: "italic"
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>January Rank 1 Interview with Grimm</h1>


          <p style={size13}>

            By: Psynight - February 19, 2018
          </p>

          <img src={"../ArticleImages/Grimm1.jpg"} style={imgCenterStyle} className="img-fluid" id="grimm1" alt="grimm1" />
          <p style={answerStyle}>
            Welcome to the first ever interview with Nova Blitz HQ.
            The goal will be to highlight the monthly rank 1 players and get their insights into the meta and what it takes to get to the top.
          </p>
          <p style={questionStyle}>
            Congratulations on getting to the top!  How long have you been playing Nova Blitz?
          </p>
          <p style={answerStyle}>
            About two years ago when the Youtuber/Twitch Streamer Noxious made a YT video showcasing the game.
          </p>
          <p style={interviewerNoteStyle}>
            I looked up some Nova Blitz videos Noxious recorded two years ago with the thought of including them in the article, but WOW the game has changed dramatically in the past two years.
            Cards, UI everything is very different so I thought it would be more confusing than helpful for new players.
          </p>
          <p style={questionStyle}>
            Is this your first time at rank 1?
          </p>
          <p style={answerStyle}>
            No, I have gotten rank 1 multiple times when the playerbase was quite low. This is the 1st time since the influx of new players though.
          </p>
          <p style={questionStyle}>
            Do you have a favorite faction combo?
          </p>
          <p style={answerStyle}>
            {"Definitely Arcane and Tech. Admittedly it isn't as good as it used to be since the game is more tempo driven then it used to be. "}
          </p>
          <p style={questionStyle}>
            {"What's your favorite deck currently?"}
          </p>
          <p style={answerStyle}>
             Hmm, tough question for sure. Probably any variant of Tech/Arcane control. There are so many different ways to build it and that makes the deck building process really fun.
          </p>
          <p style={questionStyle}>
            {"Do you have an example?"}
          </p>
          <img src={"../ArticleImages/GrimmDeckExample.jpg"} style={imgCenterStyle} className="img-fluid" id="grimmdeck" alt="grimmdeck"  />
          <p style={questionStyle}>
            Did you grind with one deck, or was it more quest of the day type grinding?
          </p>
          <p style={answerStyle}>
            I tried a myriad of different decks since grinding with one can be quite boring. People can also counter queue you quite easily if they wanted to so switching between decks is a good idea.
          </p>
          <p style={interviewerNoteStyle}>
            Interview Note: Due to the current amount of active players once you are matched up with someone it is likely that you will play them 2-3 times in a row if you immediately requeue.
            Counter Queueing is selecting a deck that would do well against the deck you just played against.
          </p>
          <p style={questionStyle}>
            Do you have a preferred archtype?  (aggro, mid range, control)
          </p>
          <p style={answerStyle}>
            Definitely control.
          </p>
          <p style={questionStyle}>
            Do you have any advice to new players?
          </p>
          <p style={answerStyle}>
            As for advice to get started, I would grind draft while also trying to draft Nature or Arcane as much as possible. I would then invest those resources from draft into building up your Nature and Chaos collection as they are certainly the strongest factions right now. They also have a lot of good commons and rares. Play-wise, I would suggest paying close attention to things like initiative while also trying to play certain cards that benefit from you having initiative as quickly as possible - e.g big flying units like Blood Lord.
          </p>
          <p style={interviewerNoteStyle}>
            Interview Note: Draft games can take a very long time to queue up against S.A.R.A.H. the AI, it may take a few minutes but you will get queued up with her if a human player does not come along.
          </p>
          <p style={questionStyle}>
            Thanks for your time and good luck next month!
          </p>
          <p style={answerStyle}>
            Thanks for all of the questions!
          </p>
        </div>
          <ArticleComments articleId={"1"} />
      </div>


    );
  }
}

export default GrimmInterview;



// WEBPACK FOOTER //
// ./src/Articles/GrimmInterview.js